export const ItemMenu = [
    {
      title: 'Home',
      url: '#',
      cName : 'nav-link'
    } ,
  
    {
      title: 'Trips',
      url: '#',
      cName : 'nav-link'
    } ,
    
    {
      title: 'Contact',
      url: '#contact',
      cName : 'nav-link'
    } ,

    {
      title: 'Price',
      url: '#price',
      cName : 'nav-link'
    } ,
  
    {
      title: 'About Us',
      url: '#',
      cName : 'nav-link'
    }
  ]